module.exports = __webpack_public_path__ + "img/phase1.ac62819a.png";